import TableCard from '../../components/TableCard'
import AltRouteIcon from '@mui/icons-material/AltRoute';
import EditRoadIcon from '@mui/icons-material/EditRoad';
import { useEffect, useState } from 'react';
import { buscarWorkflow, buscarWorkflowPorTexto } from '../../services/api-planejamento-tributario.service';
import ModalWorkFlow from './ModalWorflow';
import MensagemErro from '../../components/MensagemErro';

const Workflow = () => {
    const [data, setData] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [itemSelecionado, setItemSelecionado] = useState({})
    const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
    const [msg, setMsg] = useState('')

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await buscarWorkflow();
                setData(handleOrganizaData(response.processosWkfl))
            } catch (error) {
                setMsg(error.response.data.mensagem)
                setOpenSnackbarErro(true)
            }

        }

        fetchData()
    }, [])

    const columns = ['Nome', 'Descrição', 'Data de Alteração']

    const handleOrganizaData = (response) => {
        const newResponse = response.map(item => {
            return {
                nome: item.nome,
                descricao: item.descricao,
                dtAlteracao: (new Date(item.dtAlteracao ?? item.dtCadastro).toLocaleDateString()),
                botoes: [
                    { icon: <EditRoadIcon />, title: 'Editar', onClick: () => handleOpenModal(item) }
                ]
            }
        })
        return newResponse;

    }

    const handleCloseModal = () => {
        setItemSelecionado({})
        setOpenModal(false)
    }

    const handleOpenModal = (dados) => {
        setItemSelecionado(dados)
        setOpenModal(true)
    }

    const handleCloseSnackbarErro = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackbarErro(false);
    };

    const handlePesquisaPorTexto = async (texto) => {
        try {
            const response = await buscarWorkflowPorTexto(texto)

            if (response) {
                setData(handleOrganizaData(response.processosWkfl))
            } else {
                setData([])
            }
        } catch (error) {
            setMsg(error.response.data.mensagem)
            setOpenSnackbarErro(true)
        }

    }

    return (
        <div>
            <TableCard
                iconHeader={<AltRouteIcon fontSize='1rem' />}
                titleHeader="Workflow"
                data={data}
                setData={setData}
                columns={columns}
                textHeaderCard='nome'
                handleDebounce={handlePesquisaPorTexto}
            />
            <ModalWorkFlow
                open={openModal}
                onClose={handleCloseModal}
                data={itemSelecionado}
            />
            <MensagemErro
                open={openSnackbarErro}
                handleClose={handleCloseSnackbarErro}
                msg={msg}
            />
        </div>
    )
}

export default Workflow